import { Entity, FieldType, PersistenceType, SecurityRuleWithCondition } from 'gossamer-unified';
import { Institution } from './Institution';
import { UserView } from './UserView';
import { Event } from './Event';

export interface LivestreamSessionRow {
  id: string;
  user_id: string;
  title: string;
  description: string;
  start: string;
  end: string;
  status: string;
  event_id: number;
  egress_id: string;
  institution_id: number;
  created_at: string;
  updated_at: string;
}

export const LivestreamSession: Entity<LivestreamSessionRow> = {
  id: 'LivestreamSession',
  title: 'Livestream Session',
  service: 'main',
  rowLabel: (row: LivestreamSessionRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.livestream_session',
  },
  security: (Event.security || []).map((rule) => {
    const newRule = { ...rule } as SecurityRuleWithCondition;
    if (newRule.condition) {
      newRule.condition = `id IN (select livestream_session_id from public.event where ${newRule.condition})`;
    }
    return newRule;
  }),
  defaultSort: [['title', 'ASC']],
  defaultFilters: [{ fieldId: 'title', operator: 'ct', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    title: {
      seq: 10,
      type: FieldType.Text,
      label: 'Title',
      mandatory: true,
      listColumn: true,
    },
    description: {
      seq: 15,
      type: FieldType.Richtext,
      label: 'Description',
      mandatory: true,
    },
    start: {
      seq: 20,
      type: FieldType.Datetime,
      label: 'Starts At',
      mandatory: true,
    },
    end: {
      seq: 25,
      type: FieldType.Datetime,
      label: 'Ends At',
    },
    status: {
      seq: 30,
      type: FieldType.Text,
      label: 'Status',
      mandatory: true,
      listColumn: true,
    },
    event_id: {
      seq: 35,
      type: FieldType.Reference,
      label: 'Event',
      refEntity: Event,
      mandatory: true,
      listColumn: false,
    },
    egress_id: {
      seq: 40,
      type: FieldType.Text,
      label: 'Egress Id',
      mandatory: true,
    },
    institution_id: {
      seq: 45,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
      mandatory: true,
      listColumn: false,
    },
    user_id: {
      seq: 50,
      type: FieldType.Reference,
      label: 'Created By',
      refEntity: UserView,
      mandatory: true,
    },
    created_at: {
      seq: 55,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
    updated_at: {
      seq: 60,
      label: 'Updated At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
